/**
 * @generated SignedSource<<2ac1cdae3690425ac2752f64d7ab9b53>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WorkflowStatus = "BUSY" | "IDLE" | "UNOBTAINABLE" | "%future added value";
export type AclItem = {
  actions: ReadonlyArray<string>;
  role: string;
};
export type VideoAccessAclMutation$variables = {
  acl: ReadonlyArray<AclItem>;
  id: string;
};
export type VideoAccessAclMutation$data = {
  readonly updateEventAcl: {
    readonly acl: ReadonlyArray<{
      readonly actions: ReadonlyArray<string>;
      readonly info: {
        readonly assignableActions: ReadonlyArray<string> | null | undefined;
        readonly implies: ReadonlyArray<string> | null | undefined;
        readonly label: { default: string } & Record<string, string | undefined>;
        readonly safeActions: ReadonlyArray<string>;
      } | null | undefined;
      readonly role: string;
    }>;
    readonly workflowStatus: WorkflowStatus;
  };
};
export type VideoAccessAclMutation = {
  response: VideoAccessAclMutation$data;
  variables: VideoAccessAclMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "acl"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "acl",
    "variableName": "acl"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AclItemWithInfo",
  "kind": "LinkedField",
  "name": "acl",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoleInfo",
      "kind": "LinkedField",
      "name": "info",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "implies",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "safeActions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "assignableActions",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workflowStatus",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VideoAccessAclMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AuthorizedEvent",
        "kind": "LinkedField",
        "name": "updateEventAcl",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "VideoAccessAclMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AuthorizedEvent",
        "kind": "LinkedField",
        "name": "updateEventAcl",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9f7f8426291dd1bc437be13c956af6cf",
    "id": null,
    "metadata": {},
    "name": "VideoAccessAclMutation",
    "operationKind": "mutation",
    "text": "mutation VideoAccessAclMutation(\n  $id: ID!\n  $acl: [AclItem!]!\n) {\n  updateEventAcl(id: $id, acl: $acl) {\n    acl {\n      role\n      actions\n      info {\n        label\n        implies\n        safeActions\n        assignableActions\n      }\n    }\n    workflowStatus\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7d6dcd5ea687412dff098da9f9e9eee5";

export default node;
